import React from 'react';
import { Button } from '@iwoca/orion';
import clsx from 'clsx';
import { PersonalDetailsType } from 'components/Signup/PersonalDetails/PersonalDetails';
import { useMultiAddressInput } from '../MultiAddressInput.helpers';
import styles from './AddressTabs.module.css';

type TProps = Pick<
  ReturnType<typeof useMultiAddressInput>,
  'addresses' | 'targetAddressIndex' | 'setTargetAddressIndex' | 'errors'
> & {
  personIndex: number;
  personRole: PersonalDetailsType['role'];
};

export const AddressTabs = ({
  addresses,
  targetAddressIndex,
  setTargetAddressIndex,
  errors,
  personIndex,
  personRole,
}: TProps) => {
  if (addresses.length <= 1) {
    return null;
  }

  return (
    <div className={styles.addressTabs}>
      {addresses.map((_, index) => (
        <Button
          className={clsx(styles.addressTab, {
            [styles.active]: index === targetAddressIndex,
            [styles.hasError]: Boolean(
              personRole === 'applicant'
                ? errors.applicant?.residentialAddresses?.[index]
                : errors.guarantor?.[personIndex]?.residentialAddresses?.[
                    index
                  ],
            ),
          })}
          data-testid={`address-tab-${index + 1}`}
          key={index}
          size="small"
          type="button"
          onClick={() => setTargetAddressIndex(index)}
          variant={index === targetAddressIndex ? 'denim' : 'secondary-alt'}
        >
          Address {index + 1}
        </Button>
      ))}
    </div>
  );
};
